"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FIELD_MAPPING = exports.NOTES_AVAILABILITY_CHOICES = exports.CALL_LOG_WITH_NOTES = exports.CALL_LOG_WITHOUT_NOTES = exports.ACTION_TYPES_CHOICES = void 0;
const utils_1 = require("../../utils/utils");
const filterCallRecordConstants_1 = require("../filterCallRecord/filterCallRecordConstants");
const ACTION_TYPE_SEND_SMS = 0;
const ACTION_TYPE_CALL_LOG = 1;
const ACTION_TYPE_PARTNER_CUSTOM = 2;
const ACTION_TYPE_DELETE_INSTALMENT = 3;
const ACTION_TYPE_FLAG_AS_DO_NOT_CALL = 4;
const ACTION_TYPE_CUSTOM_LOAN_NOTES = 5;
const ACTION_TYPE_ESCALATE_TO_FIELD_RECOVERY = 6;
const ACTION_TYPE_RED_FLAG = 7;
const ACTION_TYPE_SEND_SMS_INITIAL = 8;
const ACTION_TYPE_AGENT_DROPPED_CALL = 9;
const ACTION_TYPE_CUSTOM_USER_NOTES = 10;
exports.ACTION_TYPES_CHOICES = [
    { value: '', label: 'Select action type' },
    { value: ACTION_TYPE_SEND_SMS, label: 'Send SMS' },
    { value: ACTION_TYPE_CALL_LOG, label: 'Call Log' },
    { value: ACTION_TYPE_PARTNER_CUSTOM, label: 'Partner Custom' },
    { value: ACTION_TYPE_DELETE_INSTALMENT, label: 'Delete Instalment' },
    { value: ACTION_TYPE_FLAG_AS_DO_NOT_CALL, label: 'Flag As Do Not Call' },
    { value: ACTION_TYPE_CUSTOM_LOAN_NOTES, label: 'Custom Loan Notes' },
    { value: ACTION_TYPE_ESCALATE_TO_FIELD_RECOVERY, label: 'Escalate to field recovery' },
    { value: ACTION_TYPE_RED_FLAG, label: 'Red Flag' },
    { value: ACTION_TYPE_SEND_SMS_INITIAL, label: 'Send SMS Initial' },
    { value: ACTION_TYPE_AGENT_DROPPED_CALL, label: 'Agent Dropped Call' },
    { value: ACTION_TYPE_CUSTOM_USER_NOTES, label: 'Custom User Notes' },
];
exports.CALL_LOG_WITHOUT_NOTES = 1;
exports.CALL_LOG_WITH_NOTES = 2;
exports.NOTES_AVAILABILITY_CHOICES = [
    { value: '', label: 'Select notes availability' },
    { value: exports.CALL_LOG_WITHOUT_NOTES, label: 'No notes' },
    { value: exports.CALL_LOG_WITH_NOTES, label: 'With notes' },
];
exports.FIELD_MAPPING = new Map([
    ['action_type', utils_1.mapStatusChoices(exports.ACTION_TYPES_CHOICES)],
    ['notes_availability', utils_1.mapStatusChoices(exports.NOTES_AVAILABILITY_CHOICES)],
    ['category', utils_1.mapStatusChoices(filterCallRecordConstants_1.SCHEDULE_CATEGORY_CHOICES)],
]);
